import SVGIconWrapper from "./SVGIconWrapper"

const IconAngleLeftBold = (props) => (
    <SVGIconWrapper
        fill={props.fill ?? "#000000"}
        style={props.style}
        viewBox="0 0 298.6 500"
        iconClass={`icon--angle-left-bold ${props.iconClass}`}
        wrapperClass={props.wrapperClass}
        onClick={props.onClick}
    >
        <path d="M0 250l250 250 48.6-48.6L97.2 250 298.6 48.6 250 0 0 250" />
    </SVGIconWrapper>
)

export default IconAngleLeftBold